import { createArray, random } from 'helpers';
import * as setup from 'setup';
import Danger from './Danger';

export default class DangerAntWarrior extends Danger {

    constructor(gameState: GameState, props?: DangerProps, state?: any) {
        super(gameState, 'antWarrior',  setup.dangers.antWarrior, {
            ...props,
            movingTextures: createArray(15, i => `danger/antWarrior/danger-antWarrior-moving-${i + 1}.png`),
        }, state);

        // Initialize
        this.x = (props?.x || (random(-1, 1, true) + this.colony.cell.x)) * setup.map.cells.size;
        this.y = (props?.y || (random(-1, 1, true) + this.colony.cell.y)) * setup.map.cells.size;
        this.zIndex = 4;
    }

    init = () => {
        this.findTarget();
    }

    findTarget = () => {
        // Get closest Ant
        const targets = [
            this.gameState.entities.ants.warriors.active,
            this.gameState.entities.ants.workers.active,
            this.gameState.entities.ants.explorers.active,
        ];
        this.target = this.getClosestPreferredTarget(targets);

        // Attack target if close enough, otherwise move
        if (this.target && this.isCloseToTarget(this.target)) {
            this.attackTarget(this.target, this.findTarget);
        } else if (this.target?.getClosestTarget(this.gameState.entities.dangers.antWorkers.active, this.getSearchDistance())) {
            this.moveTo(this.target.cell, this.target.size / 2, this.findTarget);
        } else {
            // Get closest DangerAntWorker
            const closestWorker = this.getClosestTarget(this.gameState.entities.dangers.antWorkers.active);
            if (closestWorker) {
                this.wanderTo(closestWorker.cell, 0.7, this.findTarget);
            } else {
                this.wanderTo(this.colony.cell, 0, this.findTarget);
            }
        }
    }

    getKillChance = () => {
        // If first attack lower kill chance, otherwise use normal
        return ((this.gameState.entities.dangers.antWarriors.created === 1 && !this.kills) ? 0.5 : 1) * (this.setup.killChance || 0);
    }

    getSearchDistance = () => {
        // If calories are too high, expand search distance to attack everything
        return this.gameState.calories > 2000 ? setup.map.cells.wide : this.setup.searchDistance;
    }

}